/* Homepage data — real class names / IDs / icon paths from the reference DOM.
   Sport icon PNGs (assets/images/events/menu-{id}.png) are live-server-only → placeholder
   via IconImg. Casino tiles / thumbs / promo use the real copied Site Images. */

export const IMG = '/images/reddy';
export const EVT = '/images/reddy/events'; // where real menu-{id}.png go when available
// gold rounded-square placeholder for missing sport icons
export const ICON_PH =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><rect x='2' y='2' width='20' height='20' rx='5' fill='%23c9a24b'/></svg>";

// Sports (id = reference sport id used for /sports/{id} + menu-{id}.png)
const SPORTS = [
  { id: '4', label: 'Cricket', href: '/cricket' },
  { id: '1', label: 'Football', href: '/soccer' },
  { id: '2', label: 'Tennis', href: '/tennis' },
  { id: '979797', label: 'Fantasy 11', href: '#', tag: true },
  { id: '969696', label: 'Cock Fight', href: '#', tag: true },
  { id: '2378961', label: 'Politics', href: '/election' },
  { id: '99998', label: 'Casino', href: '/casino', hot: true },
  { id: '99991', label: 'Sports Book', href: '/sportsbook' },
  { id: '7', label: 'Horse Racing', href: '/horse-racing' },
  { id: '4339', label: 'Greyhound Racing', href: '/greyhound-racing' },
  { id: '100000', label: 'Other', href: '#' },
  { id: '99990', label: 'Binary', href: '/binary' },
  { id: '99994', label: 'Kabaddi', href: '/kabaddi' },
  { id: '7522', label: 'Basketball', href: '/basketball' },
  { id: '7511', label: 'Baseball', href: '/baseball' },
  { id: '20', label: 'Table Tennis', href: '/table-tennis' },
  { id: '998917', label: 'Volleyball', href: '/volleyball' },
  { id: '7524', label: 'Ice Hockey', href: '/ice-hockey' },
  { id: '5', label: 'Rugby', href: '/rugby' },
  { id: '26420387', label: 'Mixed Martial Arts', href: '/mma' },
  { id: '3503', label: 'Darts', href: '/darts' },
  { id: '29', label: 'Futsal', href: '/futsal' },
  { id: '99989', label: 'Genius', href: '#' },
];
const icon = (id) => `${EVT}/menu-${id}.png`;

export const NAV_ITEMS = [
  { id: 'home', label: 'Home', href: '/', icon: `${EVT}/menu-home.png`, active: true },
  { id: 'inplay', label: 'in-play', href: '/inplay', icon: `${EVT}/menu-inplay.png` },
  ...SPORTS.map((s) => ({ ...s, icon: icon(s.id) })),
];

export const SIDEBAR_ITEMS = SPORTS.map((s) => ({ ...s, icon: icon(s.id) }));

export const SIDEBAR_PROMO = `${IMG}/sidebar-slider-casino-image-1.png`;
export const WHATSAPP_ICON = `${IMG}/whatsapp-icon.png`;

/* Casino provider tiles — real Site Images (img:null => fallback tile) */
export const CASINO_TILES = [
  { label: 'MAC88 Virtual', img: `${IMG}/mac88-games.webp` },
  { label: 'Mac Excite', img: `${IMG}/mac-exite.webp` },
  { label: 'Ezugi', img: `${IMG}/ezugi.webp` },
  { label: 'Turbo Games', img: `${IMG}/turbo-games.webp` },
  { label: 'Insta Live', img: `${IMG}/insta-live.png` },
  { label: 'JILI', img: `${IMG}/jii.webp` },
  { label: 'Gamzix', img: `${IMG}/gamzix.webp` },
  { label: 'Sexy', img: `${IMG}/sexy.png` },
  { label: 'Popok', img: `${IMG}/popok.webp` },
  { label: 'Mac88 Casino', img: `${IMG}/mac88-casino.webp` },
  { label: 'Creed', img: `${IMG}/creed.webp` },
  { label: 'Smartsoft', img: `${IMG}/smart-soft-gaming.webp` },
  { label: 'Spribe', img: `${IMG}/spribe.webp` },
  { label: 'Evolution', img: `${IMG}/evolution.webp` },
  { label: 'Mac Sexy', img: `${IMG}/mac-sexy.png` },
  { label: 'KingMidas', img: `${IMG}/kingmidas.png` },
  { label: 'Betgames', img: null },
  { label: 'Bikini Games', img: `${IMG}/bikini-games-gif.gif` },
];

/* Match data — o = [col1, colX, col2]; col = null (dash) | { b:{p,v}, l:{p,v} } */
const b = (p, v) => ({ p, v });
export const SPORT_SECTIONS = [
  {
    key: 'cricket', title: 'Cricket', iconId: '4',
    rows: [
      { t: 'The Hundred - Womens', s: 'The Hundred - Womens', live: true, d: '21 Jul', tm: '02:15 PM', ic: ['fancy', 'bm'], o: [null, null, null] },
      { t: 'The Hundred', s: 'The Hundred', live: true, d: '21 Jul', tm: '11:00 PM', ic: ['fancy', 'bm'], o: [null, null, null] },
      { t: 'Netherlands v Namibia', s: 'Others', live: true, d: '31 Jul', tm: '02:30 PM', ic: ['tv', 'p'], o: [{ b: b('2.66') }, null, { b: b('1.42') }] },
      { t: 'Kenya v Bahrain', s: 'Others', live: true, d: '31 Jul', tm: '03:30 PM', ic: ['tv', 'p'], o: [{ b: b('2.2') }, null, { b: b('1.6') }] },
      { t: 'Northamptonshire v Leicestershire', s: 'Metro Bank One Day Cup', live: true, d: '31 Jul', tm: '03:30 PM', ic: ['fancy', 'bm'], o: [{ b: b('1.84', '63.08'), l: b('2.12', '6.69') }, null, { b: b('1.9', '7.46'), l: b('2.18', '1.74') }] },
      { t: 'Yorkshire v Durham', s: 'Metro Bank One Day Cup', live: true, d: '31 Jul', tm: '03:30 PM', ic: ['fancy', 'bm'], o: [{ b: b('1.1', '3554.14'), l: b('1.11', '333.92') }, null, { b: b('10', '37.02'), l: b('11', '3554.14') }] },
      { t: 'Essex v Hampshire', s: 'Metro Bank One Day Cup', live: true, d: '31 Jul', tm: '03:30 PM', ic: ['fancy', 'bm'], o: [{ b: b('1.25', '136.61'), l: b('1.28', '108.68') }, null, { b: b('4.5', '30.86'), l: b('5', '33.67') }] },
      { t: 'Derbyshire v Glamorgan', s: 'Metro Bank One Day Cup', live: true, d: '31 Jul', tm: '03:30 PM', ic: ['bm'], o: [{ b: b('1.3', '55.21'), l: b('1.33', '606.93') }, null, { b: b('4', '135.28'), l: b('4.4', '16.31') }] },
    ],
  },
  {
    key: 'football', title: 'Football', iconId: '1',
    rows: [
      { t: 'Henan Songshan Longmen v Dalian Yingbo', s: 'Chinese Super League', live: true, d: '31 Jul', tm: '12:15 PM', ic: ['tv', 'p'], o: [{ b: b('1.37', '1972.04'), l: b('1.38', '11.58') }, { b: b('5.3', '3.02'), l: b('5.4', '3.18') }, { b: b('11', '23.24'), l: b('11.5', '74.14') }] },
      { t: 'Broadbeach United vs. Logan Lightning', s: 'Australia / U23 Queensland Premier League 1', live: true, d: '31 Jul', tm: '02:00 PM', ic: ['p'], o: [{ b: b('2.75') }, null, { b: b('1.96') }] },
      { t: 'Casuarina FC Reserves vs. Hellenic AC Reserves', s: 'Australia / Northern Territory Premier League', live: true, d: '31 Jul', tm: '02:30 PM', ic: ['p'], o: [{ b: b('3.6') }, null, { b: b('1.83') }] },
      { t: 'Portimonense SAD vs. Nottingham Forest', s: 'International Clubs / Club Friendly Games', live: true, d: '31 Jul', tm: '03:30 PM', ic: ['p'], o: [{ b: b('4.2') }, null, { b: b('1.73') }] },
      { t: 'Northcote City vs. Eltham Redbacks FC', s: 'Victoria Premier League 1', live: true, d: '31 Jul', tm: '06:00 PM', ic: ['p'], o: [{ b: b('1.04') }, null, { b: b('9.99') }] },
    ],
  },
  {
    key: 'tennis', title: 'Tennis', iconId: '2',
    rows: [
      { t: 'ATP Washington D.C. 2026', s: 'ATP Washington D.C. 2026', live: true, d: '22 Jul', tm: '05:30 AM', ic: ['bm'], o: [null, null, null] },
      { t: 'WTA Washington 2026', s: 'WTA Washington 2026', live: true, d: '24 Jul', tm: '05:30 AM', ic: ['bm'], o: [null, null, null] },
      { t: 'WTA Memphis 2026', s: 'WTA Memphis 2026', live: true, d: '25 Jul', tm: '05:30 AM', ic: ['bm'], o: [null, null, null] },
      { t: 'CO Bittoun Kouzmine v Ma Dhamne', s: 'ATP Challenger Liberec', live: true, d: '31 Jul', tm: '12:30 PM', ic: ['tv', 'p'], o: [{ b: b('1.43', '113.80'), l: b('1.44', '309.33') }, null, { b: b('3.25', '128.36'), l: b('3.3', '276.53') }] },
    ],
  },
];

export const UPCOMING = {
  key: 'cricket', title: 'Cricket', iconId: '4',
  rows: [
    { t: 'Trinbago Knight Riders SRL v Antigua And Barbuda', s: 'Simulated Reality League / Caribbean Premier League', d: '31 Jul', tm: '06:30 PM', ic: [], o: [null, null, null] },
    { t: 'Gujarat Titans SO v Delhi Capitals SO', s: 'Others', d: '31 Jul', tm: '05:00 PM', ic: ['tv', 'bm'], o: [null, null, null] },
    { t: 'New Zealand T10 vs Pakistan T10', s: 'Others', d: '31 Jul', tm: '05:00 PM', ic: ['tv', 'bm'], o: [null, null, null] },
    { t: 'The Rock vs Solo Sikoa', s: 'Others', d: '31 Jul', tm: '05:10 PM', ic: ['bm'], o: [null, null, null] },
    { t: 'Multan Sultans SO v Lahore Qalandars SO', s: 'Others', d: '31 Jul', tm: '05:30 PM', ic: ['tv', 'bm'], o: [null, null, null] },
    { t: 'Gloucestershire v Surrey', s: 'Metro Bank One Day Cup', d: '31 Jul', tm: '06:30 PM', ic: ['tv', 'bm'], o: [{ b: b('1.61', '2') }, { b: b('1.69', '2') }, { b: b('2.44', '1.39'), l: b('2.64', '1.22') }] },
  ],
};

/* ===== Mobile homepage thumb-grid (custom-thumb-section) =====
   Reference thumbnails are live-server GIFs/PNGs (speedcdn.io/frontend_config/tiger/images/*).
   `img` holds the real reference filename (for a live feed later); it won't load off the live
   server, so GameThumbGrid falls back to /images/reddy/thumbs/{slug}.gif → crimson tile + name.
   Empty `img` → straight to the placeholder. */
export const THUMB_CDN = 'https://speedcdn.io/frontend_config/tiger/images';

// custom-thumb-section grid (2-row horizontal scroller on mobile)
export const THUMB_GAMES = [
  { slug: 'ezugi', name: 'EZUGI', img: '17741827173955390.gif' },
  { slug: 'insta-live', name: 'INSTA LIVE', img: '17721100879567338.gif' },
  { slug: 'aviator', name: 'AVIATOR', img: '17814461064832706.gif' },
  { slug: 'bikini-games', name: 'BIKINI GAMES', img: '17721101123183452.gif' },
  { slug: 'lightning', name: 'LIGHTNING', img: '17721100327328503.gif' },
  { slug: 'sexy', name: 'SEXY', img: '17721100393698204.gif' },
  { slug: 'mines', name: 'MINES', img: '17753849247758330.gif' },
  { slug: 'chicken-road', name: 'CHICKEN ROAD', img: '17721100468285011.gif' },
  { slug: 'color-prediction', name: 'COLOR PREDICTION', img: '' },
];

// "new launch" banner carousel (top-baner swiper → static horizontal-scroll strip)
export const NEW_LAUNCH = [
  { slug: 'hand-cricket', name: 'HAND CRICKET', img: '17840278215010136.png' },
  { slug: 'wicket-blast', name: 'WICKET BLAST', img: '17650471925630440.png' },
  { slug: 'matka', name: 'MATKA', img: '17828557905357634.png' },
  { slug: 'black-jack', name: 'BLACK JACK', img: '17803164468831882.png' },
  { slug: 'bomb-defuse', name: 'BOMB DEFUSE', img: '' },
  { slug: 'deal-or-no-deal', name: 'DEAL OR NO DEAL', img: '' },
];
